import { createContext } from 'react';

export interface IAdCounterContext {
  getAndIncrement: () => number;
}

// Providing a default function that warns if used outside a provider.
const defaultContext: IAdCounterContext = {
  getAndIncrement: () => {
    console.warn('useAdCounter used outside of a AdCounterProvider. Defaulting to 0.');
    return 0;
  },
};

export const AdCounterContext = createContext<IAdCounterContext>(defaultContext);